import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const SECTIONS = [
    { id: 'hotel', label: 'El Hotel' },
    { id: 'galeria', label: 'Galería' },
    { id: 'ubicacion', label: 'Ubicacion' },
    { id: 'restaurantes', label: 'Restaurantes' },
];

const HotelNav = ({ activeSection: initialSection = 'hotel' }) => {

    const { t } = useTranslation();
    const [activeSection, setActiveSection] = useState(initialSection);

    const handleClick = (id) => {
        setActiveSection(id);

        const element = document.getElementById(id);

        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    };

    return (
        <nav
            className="mb-4 cc-hotel-menu mb-md-80"
            aria-label={t('Navegación del hotel')}
        >
            <div className="overflow-hidden c-tabs-swiper">
                <swiper-container>
                    {SECTIONS.map(({ id, label }, index) => {
                        const isActive = activeSection === id;

                        return (
                            <swiper-slide
                                key={id}
                                style={{
                                    width: '618px',
                                    marginRight: '64px',
                                }}
                                role="group"
                                aria-label={`${index + 1} / ${SECTIONS.length}`}
                                className={isActive ? 'swiper-slide-active' : ''}
                            >
                                <button
                                    type="button"
                                    className={`btn c-tabs-swiper_btn-tab ${isActive ? 'active' : ''
                                        }`}
                                    onClick={() => handleClick(id)}
                                    aria-current={isActive ? 'page' : undefined}
                                >
                                    {t(label)}
                                </button>
                            </swiper-slide>
                        );
                    })}
                </swiper-container>
            </div>
        </nav>
    );
};

export default HotelNav;